import React from "react";
import bgDesktop from "assets/img/newversion/herosection-desktop.png";
import bgMobile from "assets/img/newversion/herosection-mobile.png";

export function HeroSection() {
  return (
    <section className="hero-section position-relative w-100 overflow-hidden">
      {/* Background Image só no desktop */}
      <div className="hero-bg position-absolute top-0 start-0 w-100 h-100 d-none d-md-block">
        <img
          src={bgDesktop}
          alt="Equipe engajada e motivada trabalhando juntos"
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
        />
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-10"></div>
      </div>

      {/* MOBILE Layout */}
      <div className="d-block d-md-none position-relative">
        {/* Fundo com a imagem mobile */}
        <div className="hero-bg-mobile position-absolute top-0 start-0 w-100">
          <img
            src={bgMobile}
            alt="Equipe engajada"
            className="w-100"
            style={{ objectFit: "cover" }}
          />
          {/* overlay leve para contraste */}
          <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75"></div>
        </div>

        {/* Conteúdo por cima da imagem */}
        <div className="position-relative p-4 text-center">
          {/* Título */}
          <h1 className="h1 fw-bold text-dark mb-3 lh-base">
            Reduza custos e tenha uma equipe mais engajada e motivada.
          </h1>

          {/* Descrição */}
          <p
            className="text-dark mb-4"
            style={{ fontSize: "16px", lineHeight: "1.5" }}
          >
            Benefícios de saúde e bem-estar com alto valor percebido e baixo
            custo. Planos sob medida para pequenas, médias e grandes empresas.
            Atraia, retenha e engaje seus talentos.
          </p>

          {/* Botão */}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfr-3eavfn5mn2OPqkt8XeSw8VTrHHsqsvbsno5VtPoK1r5Fw/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="btn w-100 fw-bold text-white py-3 rounded-pill shadow-sm"
            style={{
              background: "linear-gradient(135deg, #28a745 0%, #007bff 100%)",
              border: "none",
              fontSize: "15px",
            }}
          >
            Quero uma proposta personalizada
          </a>
        </div>
      </div>

      {/* DESKTOP Layout */}
      <div className="d-none d-md-block position-relative">
        <div className="container-fluid py-5">
          <div className="row align-items-center min-vh-50">
            <div className="col-lg-8 col-xl-6">
              <div className="ps-4 ps-lg-5">
                {/* Title */}
                <div className="mb-4">
                  <h1
                    className="display-5 fw-bold text-dark mb-0"
                    style={{ maxWidth: "504px", lineHeight: "1.2" }}
                  >
                    Reduza custos e tenha uma equipe mais engajada e motivada.
                  </h1>
                </div>

                {/* Description */}
                <div className="mb-4">
                  <p
                    className="lead text-dark mb-0"
                    style={{
                      maxWidth: "403px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    Benefícios de saúde e bem-estar com alto valor percebido e
                    baixo custo. Planos sob medida para pequenas, médias e
                    grandes empresas. Atraia, retenha e engaje seus talentos.
                  </p>
                </div>

                {/* Botão */}
                <div>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfr-3eavfn5mn2OPqkt8XeSw8VTrHHsqsvbsno5VtPoK1r5Fw/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-lg rounded-pill px-5 py-3 fw-bold shadow-sm"
                    style={{
                      background:
                        "linear-gradient(135deg, #007bff 0%, #6f42c1 100%)",
                      border: "none",
                      fontSize: "18px",
                      minWidth: "381px",
                    }}
                  >
                    Quero uma proposta personalizada
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .hero-section {
          min-height: 438px;
        }

        @media (max-width: 767.98px) {
          .hero-section {
            min-height: 800px;
          }
        }

        .min-vh-50 {
          min-height: 438px;
        }

        @media (max-width: 767.98px) {
          .min-vh-50 {
            min-height: 300px;
          }
        }

        .hero-bg img {
          border-radius: 8px;
        }
      `}</style>
    </section>
  );
}

export default HeroSection;